module.exports = __webpack_public_path__ + "static/media/space3_sm.931c72f8.jpg";